import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../utils/authUtils';

const FeedbackButton = () => {
  const [showQuickForm, setShowQuickForm] = useState(false);
  const [formData, setFormData] = useState({
    type: 'bug',
    title: '',
    description: '',
    priority: 'medium'
  });
  const [submitStatus, setSubmitStatus] = useState(null);
  const navigate = useNavigate();

  const handleQuickSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('loading');
    
    try {
      const response = await fetchWithAuth('/api/feedbacks', {
        method: 'POST',
        body: JSON.stringify({
          ...formData,
          submittedBy: localStorage.getItem('username') || 'Anonyme',
          submittedAt: new Date().toISOString(),
          status: 'open',
          userAgent: navigator.userAgent,
          url: window.location.href
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          type: 'bug',
          title: '',
          description: '',
          priority: 'medium'
        });
        setTimeout(() => {
          setShowQuickForm(false);
          setSubmitStatus(null);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du signalement:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <>
      {/* Bouton flottant */}
      <button
        onClick={() => setShowQuickForm(!showQuickForm)}
        className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-50 feedback-float-button"
        title="Signaler un bug ou suggérer une amélioration"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
      </button>

      {/* Formulaire rapide */}
      {showQuickForm && (
        <div className="fixed bottom-20 right-6 bg-white rounded-lg shadow-xl p-6 w-96 z-50 border border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">Signalement rapide</h3>
            <button
              onClick={() => setShowQuickForm(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {submitStatus === 'success' ? (
            <div className="text-center py-8">
              <div className="text-green-500 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p className="text-green-600 font-medium">Signalement envoyé avec succès !</p>
              <p className="text-gray-600 text-sm mt-1">Merci pour votre contribution</p>
            </div>
          ) : (
            <form onSubmit={handleQuickSubmit}>
              <div className="flex gap-2 mb-3">
                <select
                  value={formData.type}
                  onChange={(e) => setFormData({...formData, type: e.target.value})}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="bug">🐛 Bug</option>
                  <option value="improvement">💡 Amélioration</option>
                </select>
                
                <select
                  value={formData.priority}
                  onChange={(e) => setFormData({...formData, priority: e.target.value})}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="low">Faible</option>
                  <option value="medium">Moyenne</option>
                  <option value="high">Haute</option>
                </select>
              </div>

              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({...formData, title: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 mb-3"
                placeholder="Titre court..."
                required
              />

              <textarea
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 mb-3"
                rows="3"
                placeholder="Description..."
                required
              />

              <div className="flex gap-2">
                <button
                  type="submit"
                  disabled={submitStatus === 'loading'}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium disabled:opacity-50"
                >
                  {submitStatus === 'loading' ? 'Envoi...' : 'Envoyer'}
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/feedback')}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 text-sm"
                >
                  Voir tous
                </button>
              </div>
            </form>
          )}
        </div>
      )}
    </>
  );
};

export default FeedbackButton;